"use strict";

let moduleName = 'snippet';

module.exports = function () {
    $('.feedback-form-description').each(function () {
        if ($.data(this, moduleName + '-init')) return;
        $.data(this, moduleName + '-init', true);

        let $description = $(this),
            description = $description.html(),
            $form = $description.closest('.block_feedback').find('.feedback-form'),
            $btn = $form.find('input[type="submit"]');

        if ($btn.length && description.indexOf('#button#') !== -1) {
            $description.html(description.replace('#button#', $btn.val()))
        }
    });
};


// WEBPACK FOOTER //
// ./src/js/modules/snippetInit.js